import { ChangeDetectionStrategy, Component, inject, Input, output } from '@angular/core';
import { Router } from '@angular/router';

import { NavItem } from '../../interfaces/nav-item';

@Component({
  selector: 'locumsnest-menu-list-item',
  templateUrl: './menu-list-item.component.html',
  styleUrls: ['./menu-list-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MenuListItemComponent {
  @Input() idx: string;
  @Input() item: NavItem;
  @Input() depth: number;
  @Input() menuExpanded: boolean;
  @Input() isFirstElement: boolean;
  @Input() isLastElement: boolean;
  @Input() activeNavItem: string | null;
  @Input() filtersDisabled: boolean;
  @Input() filterCount: number;
  @Input() hospitalOfficerPath: string;
  @Input() filtersPanelExpanded: boolean;
  @Input() nestPanelExpanded: boolean;
  @Input() itemListLength: number;
  @Input() isAgencyPlatform: boolean;

  toggled = output<string>();
  clicked = output<string>();
  filterMenuClicked = output();

  private router = inject(Router);

  onItemSelected(item: NavItem) {
    if (!item.hasRightMenu) this.clicked.emit(item.displayName);
    if (item.hasRightMenu && item.code !== 'filters') {
      this.toggled.emit(item.displayName);
    }
    if (item.code === 'settings') {
      return this.router.navigateByUrl(this.hospitalOfficerPath);
    }

    if (item.code === 'filters') {
      if (!this.filtersDisabled) {
        return this.filterMenuClicked.emit();
      }
      return;
    }

    if (item.path !== null) {
      return this.router.navigateByUrl(item.path);
    }
  }

  isActive(item: NavItem): boolean {
    if (item.code === 'nest') {
      return this.nestPanelExpanded;
    }
    return item.code === this.activeNavItem;
  }
}
